import React from "react";

const LoadingSpinner = () => {
  return (
    <div className="flex justify-center py-16">
      <div className="w-12 h-12 border-4 border-accent border-t-transparent rounded-full animate-spin" />
    </div>
  );
};

export default LoadingSpinner;
